import { BreadcrumbNodeType } from '../../Components/AnnotationManager/Annotation/Breadcrumb/types';
import { WindTurbineParams, WindTurbineParser } from './windTurbineParser';

export const WIND_TURBINE = 'windturbine';

export type ParserResult = {
  path: string;
  pathObject: any;
};

export interface IParser<T> {
  name: string;
  requiredPath: string;
  optionalPath: string;
  isPathSequence(path: string): boolean;
  containsSequence(path: string): boolean;
  containsImage(path: string): boolean;
  parse(url: string, params: T): ParserResult;
  parsedRequiredPath(params: T): string;
  parsedSequencePath(params: T): string;
  parsedRequiredPathWithoutRoot(params: T): string;
  parsedFullPath(params: T): string;
  getRootNode(params: T): string;
  getBreadcrumb(params: T): BreadcrumbNodeType;
  getImageName(params: T): string | undefined;
  getAnnotationId(params: T): string | undefined;
  isPathPartial(params: T): boolean;
  getPathUntilImage(params: T): string;
  hasImagePathChanged(params: T, previousPath: string): boolean;
  hasSequencePathChanged(params: T, previousPath: string): boolean;
}

class ParserFactory {
  parsers: Map<string, IParser<any>>;

  constructor() {
    this.parsers = new Map<string, IParser<any>>();
    this.parsers.set(WIND_TURBINE, new WindTurbineParser(WIND_TURBINE));
  }

  getParser(parserType: string) {
    if (!this.parsers.has(parserType)) {
      return undefined;
    }

    return this.parsers.get(parserType);
  }
}

export const getParser = (parserType: string) => {
  const factory = new ParserFactory();
  return factory.getParser(parserType);
};

export const getMainPathPrefixes = () => {
  const factory = new ParserFactory();
  const paths: string[] = [];
  factory.parsers.forEach((parser, key) => paths.push(parser.requiredPath));
  return paths;
};
